import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import { fg } from '@atlassian/jira-feature-gating';
import {
	useJiraLossAversionAAExperiment,
	useJiraLossAversionABExperiment,
} from '../services/use-experiment/use-experiment';
import { JiraLossAversionModal } from './loss-aversion-modal';

// Preferred HOC but we need to get sign off from a FE architect to introduce new HOCs to CFE
export const JiraLossAversionExperimentInternals = () => {
	// AA experiment
	const aaExperimentIsEnabled = fg('jira_loss_aversion_standard_gate_aa');
	// This function should fire all necessary exposure events for AA experiment
	useJiraLossAversionAAExperiment({
		isExperimentEnabled: aaExperimentIsEnabled,
		extraAnalytics: {},
	});

	// AB experiment
	const abExperimentIsEnabled = fg('jira_loss_aversion_standard_gate_ab');
	// TODO: use cohort value?
	const { renderTreatment } = useJiraLossAversionABExperiment({
		isExperimentEnabled: abExperimentIsEnabled,
		extraAnalytics: {},
	});

	if (renderTreatment) {
		return <JiraLossAversionModal />;
	}
	return <></>;
};

export const JiraLossAversionExperiment = () => (
	<JSErrorBoundary
		id="jiraLossAversionExperiment"
		packageName="jiraLossAversion"
		teamName="luna-growth"
		fallback="unmount"
	>
		<JiraLossAversionExperimentInternals />
	</JSErrorBoundary>
);
